// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const CARD = `background:#fff;border-top:1px solid #DCE4F2;padding:20px 24px`;
const KICKER = `font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:var(--ink-4)`;
const NOTE = `font-size:12.5px;color:var(--ink-3);margin:4px 0 12px;line-height:1.5`;
const ROW = `padding:12px 0;border-top:1px solid #EDF1F8`;
const PILL = `flex:none;height:32px;padding:0 14px;border-radius:999px;font-family:inherit;font-size:12.5px;cursor:pointer`;

const GROUPS = [
  { kind: 'formula', title: 'Formula errors', note: 'Wrong driver keys, unknown functions, formulas that can’t be read, and circular references.' },
  { kind: 'missing', title: 'Missing forecast values', note: 'Input drivers with empty months in the forecast period.' },
  { kind: 'flags', title: 'Flags to review', note: 'Publishing waits until every red cell is accepted with a note or changed.' },
  { kind: 'fade', title: 'Long-term fade decisions', note: 'There is no history to measure the monthly fade. Set the value in Cohort model settings before you publish.' }
];

const GUARD_NOTE = 'Not enough history for a system default, so this rule is skipped for this channel and cohort model. Publishing is not blocked. Set the value in Cohort model settings to apply it.';

function FindingRow({ fd }) {
  return (
    <div style={sx(`${ROW};display:flex;gap:20px;align-items:flex-start`)}>
      <div style={sx(`flex:1;min-width:0`)}>
        <div style={sx(`font-size:13.5px;color:var(--ink);line-height:1.45`)}>{fd.title}</div>
        <p style={sx(`font-size:12.5px;color:var(--ink-3);margin:4px 0 0;line-height:1.5;word-break:break-word`)}>{fd.detail}</p>
        {fd.hint ? <div style={sx(`font-size:12px;color:var(--ink-2);margin-top:4px`)}>{fd.hint}</div> : null}
      </div>
      <button className="gmHover" onClick={fd.onAction} style={sx(`${PILL};border:none;background:#0052CD;color:#fff`)} data-hover="background:#003FA0">
        {fd.action}
      </button>
    </div>
  );
}

export default function GovernanceScreen({ vm }: { vm: any }) {
  if (!vm.showGovernance) return null;
  const findings = vm.findings || [];
  const guardRows = vm.guardFindings || [];
  const ready = !vm.reviewTodo;

  return (
    <div style={sx(`flex:1;min-height:0;overflow:auto;padding:0 0 24px`)}>
      <div style={sx(`padding:22px 24px 18px`)}>
        <div style={sx(KICKER)}>Review</div>
        <h4 style={sx(`margin:6px 0 4px;color:${ready ? 'var(--ink)' : '#E5484D'}`)}>{vm.reviewTitle}</h4>
        <p style={sx(`font-size:12.5px;color:var(--ink-3);margin:0`)}>{vm.reviewNote}</p>
      </div>

      {GROUPS.map((g) => {
        const rows = findings.filter((fd) => fd.kind === g.kind);
        return rows.length ? (
          <div key={g.kind} style={sx(CARD)}>
            <h4 style={sx(`margin:0`)}>
              {g.title} · {rows.length}
            </h4>
            <p style={sx(NOTE)}>{g.note}</p>
            {rows.map((fd) => (
              <FindingRow key={fd.id} fd={fd} />
            ))}
          </div>
        ) : null;
      })}

      {ready ? <div style={sx(`${CARD};font-size:12.5px;color:var(--ink-3)`)}>Nothing to fix. You can publish.</div> : null}

      {guardRows.length ? (
        <div data-testid="review-guard-notes" style={sx(CARD)}>
          <h4 style={sx(`margin:0`)}>
            Cohort guardrails to check · {guardRows.length}
          </h4>
          <p style={sx(NOTE)}>{GUARD_NOTE}</p>
          {guardRows.map((fd) => (
            <FindingRow key={fd.id} fd={fd} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
